<template>
	<div>
		<custom-switch
			v-model="form.is_join_allowed"
			:label="$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.isJoinAllowed')"
			class="mt-5"
		/>
		<custom-switch
			v-model="form.is_invitations_allowed"
			:label="$vuetify.lang.t('$vuetify.views.groups.dialogs.createGroup.form.isInvitationAllowed')"
			class="mt-4"
		/>
	</div>
</template>

<script>
import CustomSwitch from "@/components/items/CustomSwitch";
export default {
	name: "GroupFormSwitches",
	components: {
		CustomSwitch
	},
	props: {
		form: {
			type: Object,
			required: true
		}
	}
}
</script>

